export default __webpack_public_path__ + "static/media/left.b745c194.svg";